import { useRef } from "react"

// providers
import { useNotesContext } from "@/_providers/Notes"

// images
import closeImage from "@/assets/img/todo/icons/close.svg"

// components
import View from "@/components/pages/todo/partials/modals/View"

export default function Tray() {
  const { getMinimizedTodos, handleRemoveFromTray, loadingTray, handleRead } =
    useNotesContext()

  const viewModalRef = useRef(null)

  const handleOpenTrayTodo = (todo) => {
    viewModalRef.current.open(todo)
  }

  if (!getMinimizedTodos().length) {
    return null
  }

  return (
    <>
      <View ref={viewModalRef} handleRead={handleRead} />
      <ul className={`tray-minimized-todos ${loadingTray ? "loading" : ""}`}>
        {getMinimizedTodos().map((todo) => (
          <li key={todo.id} onClick={() => handleOpenTrayTodo(todo.todo)}>
            <span className={`priority ${todo.todo.priority?.name}`}></span>
            <b>{todo.todo?.title}</b>
            <button
              className="tray-todo-remove"
              onClick={(e) => {
                e.stopPropagation()
                handleRemoveFromTray(todo.todo_id)
              }}
              title="Премахни от tray"
            >
              <img src={closeImage} alt="Close" />
            </button>
          </li>
        ))}
      </ul>
    </>
  )
}
